import React, { useState, useEffect } from "react";
import { StandartButton } from "commons/form-controls";
import TableItem from "items/table/table";
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import PaginatorContainer from "items/paginator/paginator-container";
import DropdownController from "items/dropdown/dropdown-controller";
import SearchBlock from "../search-block/search-block";
import s from "../admin.module.scss";

const AdminAccounts = (props) => {

    const [rerender, setRerender] = useState(false);

    const [searchStart, setSearchStart] = useState(false)

    const setSelectedSort = (sort, type) => {
        if(sort === 'STATUS'){
            sortByStatus(type);
        }
        else{
            sortByOrder(sort, type)
            //props.setSort(sort);
        }
        
    }

    const sortByStatus = (status) => {
        props.setSortByStatus(status)
        setStatus(status);
    }

    const sortByOrder = (sort, type) => {
        setSort(sort, type);
        //props.setSortDirection(type)
        let items = type.split(" ");
        props.setSort(items[0], items[1]);

        //setSortBy(items[0]);
        //setRerender(!rerender);
        //setSortByDirection(items[1])
    }

    const getSort = (sort) => {
        switch(sort){
            case 'ALPHABETIC':
                return alphabetic
            case 'CREATED_AT':
                return created
            case 'UPDATED_AT':
                return updated
            case 'STATUS':
                return status
        }
        
    }

    const setSort = (type, sort) => {
        switch(type){
            case 'ALPHABETIC':
                setAlphabetic(sort);
                setCreated('CREATED_AT DESC');
                break;
            case 'CREATED_AT':
                setCreated(sort);
                setUpdated('UPDATED_AT DESC');
                setAlphabetic('ALPHABETIC DESC')
                break;
            case 'UPDATED_AT':
                setUpdated(sort);
                setCreated('CREATED_AT DESC');
                setAlphabetic('ALPHABETIC DESC')
                break;
            case 'STATUS':
                setStatus();
                break;
        }
    }

    const getHeaderComponents = (headers, selected) => {
        let retHeaders = props.tableHeader && props.tableHeader.map((item, i) => {
            let t = item
            if(item.name === 'dropdown'){
                let titles = item.items.map((title)=>{return {title: props.getValue(title.title), short_name: title.short_name, name: title.name}});
                return <DropdownController
                            items={titles}
                            name={item.name}
                            callback={setSelectedSort}
                            selected={getSort(item.title)}
                            icon={null}
                            type={item.title}
                            short_name={'short_names'}
                        /> 
            }
            else{
                return props.getValue(item)
            }
        })
        return retHeaders
    }

    const getSelectedSort = (sort) => {
        let sorting = props.tableHeader.findIndex((f, i) => {return f.title === sort})
        let ret = sorting !== -1 ? props.tableHeader[sorting].items[0].short_name : sort
        return ret;
    }

    const [sortBy, setSortBy] = useState(props.sort);
    const [sortByDirection, setSortByDirection] = useState(props.sortDirection);
    const [accounts, setAccounts] = useState(props.accounts ? props.accounts : null);
    const [companyId, setCompanyId] = useState(props.companyId ? props.companyId : null);
    const [selectedItem, setSelectedItem] = useState(props.selected);
    
    const [alphabetic, setAlphabetic] = useState(getSelectedSort('ALPHABETIC'));

    const [created, setCreated] = useState(getSelectedSort('CREATED_AT'));
    const [updated, setUpdated] = useState(getSelectedSort('UPDATED_AT'));
    const [status, setStatus] = useState(props.status);
    const [searchText, setSearchText] = useState(props.searchText);
    
    let [tableHeaders, setTableHeaders] = useState(getHeaderComponents(props.tableHeaders));

    const selectTableItem = (item) => {
        if(!props.isTopicAccounts){
            //setSelectedItem(item);
            props.setSelected(item)
            props.setAccountId((props.accounts && props.accounts.accounts) && props.accounts.accounts[item].id)
            setTableHeaders(getHeaderComponents(props.tableHeaders));
        }
    }

    const addNewCompany = () => {
        props.showRightMenu('create')
    }

    useEffect(()=>{
        setAccounts(props.accounts ? props.accounts : null)
        setCompanyId(props.companyId ? props.companyId : null)
        setSelectedItem(props.selected)
        setSortByDirection(props.sortDirection);
        //setAlphabetic(getSelectedSort('ALPHABETIC'));
        setTableHeaders(getHeaderComponents(props.tableHeaders));
        setStatus(props.status);
        setRerender(!rerender);
    }, [props])

    const editAccount = (account) => {
        props.showRightMenu('edit', 'EDIT_ACCOUNT', companyId, account)
    }

    const deleteAccount = (account) => {
        props.deleteAccount(props.companyId, account.id)
    }

    const addAccountToCompany = () => {
        if (companyId !== null || companyId !== '') {
            props.showRightMenu('create', 'ADD_ACCOUNT', companyId, null)
        } else {
            props.showRightMenu('create', 'ADD_ACCOUNT', null, null)
        }
    }

    const addItemButton = !props.isTopicAccounts ? <StandartButton 
        icon={PlusIcon} 
        fill={'white'}
        title={props.isTopicAccounts ? props.getValue('USERS') : props.getValue("CREATE_USER")}
        callback={addAccountToCompany}
    /> : null

    const getHiddenColumns = (deviceType) => {
        switch(deviceType){
            case 'mobile':
                return [2,3,4,5,6]
            case 'tablet':
                return [2,3]
            default:
                return []
        }
    }

    const searchItem = (search) => {
        if(search){
            props.search(search);
            setSearchStart(true)
        }
        else{
            setSearchText('')
            props.search('')
            setSearchStart(false)
            setRerender(!rerender)
        }
    }

    return (
        <div className={s.Admin}>
            {props.isSuperadmin && !companyId ? <PaginatorContainer /> : null}
            
            {props.showSearch ? <SearchBlock getValue={props.getValue} searchItem={searchItem} searchText={props.searchText}/> : null}
            <TableItem 
                data={[tableHeaders, props.data]}
                height={320}
                addItemButton={addItemButton}
                
                selectItem={selectTableItem}
                selectedItem={selectedItem}
                hidden={getHiddenColumns(props.deviceType)} 
                hiddenInEdit={[3,4,5,7]}        
            />
        </div>
    )
}

export default AdminAccounts;